import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Pings the server to record a page view on each client-side navigation.
// Silent on failure — analytics must never break the UI.
export function useAnalyticsTracking() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;
    lastPath.current = path;

    const token = localStorage.getItem("auth_token");
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };
    if (token) headers.Authorization = `Bearer ${token}`;

    fetch("/analytics/track", {
      method: "POST",
      headers,
      body: JSON.stringify({ path }),
      credentials: "same-origin",
      keepalive: true,
    }).catch(() => {
      /* swallow */
    });
  }, [location.pathname, location.search]);
}

import { useWebVitals } from "@/hooks/useWebVitals";

export function AnalyticsTracker() {
  useAnalyticsTracking();
  useWebVitals();
  return null;
}
